export default __webpack_public_path__ + "static/media/dk.890d6807.svg";